import ClassListPagingResultModelBase from '../_generated/modelBases/class-list-paging-result-model-base';

export default class ClassListPagingResultModel extends ClassListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
